// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.

/** Jargon → plain-English definitions, surfaced as click-to-define tooltips. */
export const GLOSSARY: Record<string, string> = {
  redaction:
    'Permanently removing sensitive text or images from a document before you share it — not just hiding them, but taking them out so they cannot be recovered.',
  flatten:
    'Turning a page into a single flat image. Once a page is flattened there is no separate text layer left, so anything under a black box is gone — you cannot select or copy it back.',
  'text layer':
    'The invisible, selectable, copy-pasteable text that sits on top of a PDF page. It is what lets you highlight words — and it is exactly what a fake redaction (a box drawn on top) leaves behind.',
  'find & redact':
    'Type a word, a name or a number and Redactwell scans the page’s text layer and drops a removable black box over every match for you to review before exporting.',
  dpi:
    'Dots per inch — how finely a redacted page is rasterised. Higher DPI is crisper and larger; 150 is plenty for most documents, 200+ for tiny print.',
  'burned in':
    'The black bars are drawn into the actual pixels of the exported image, so they are part of the picture — there is nothing layered on top that could be peeled away.',
  metadata:
    'Hidden information a PDF carries about itself — author name, the software that made it, timestamps. Redactwell drops it from the file it hands you.',
};
